import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

// Actions
import * as UsersActions from 'Shared/actions/Users.actions';

// Components
import { WpButtonGroup, WpButton } from 'Wpds/components/button';
import { WpModal, WpModalHeader, WpModalBody, WpModalFooter } from 'Wpds/components/modal';

type Props = {
  isOpen: boolean;
  toggleIsOpen: () => void;
  onContinueClick: Function;
  onCancelClick: Function;
};

const NavigationWarningModal = ({ isOpen, toggleIsOpen, onContinueClick, onCancelClick }: Props) => {
  const dispatch = useDispatch();

  const handleClick = () => {
    onContinueClick();
    toggleIsOpen();
  };

  const handleCancelClick = () => {
    onCancelClick();
    toggleIsOpen();
  };

  useEffect(() => {
    dispatch(UsersActions.updateUserFlag('has_seen_meeting_mode_navigation_warning', true));
  }, []);

  return (
    <WpModal isOpen={isOpen} size="sm">
      <WpModalHeader>Just a heads up...</WpModalHeader>
      <WpModalBody>
        Meeting mode is a collaborative experience for all attendees. That means when you click through your agenda,
        every attendee is switched to the next topic with you!
      </WpModalBody>
      <WpModalFooter>
        <WpButtonGroup>
          <WpButton onClick={handleCancelClick} variant="tertiary">
            Cancel
          </WpButton>
          <WpButton onClick={handleClick}>Let&apos;s go!</WpButton>
        </WpButtonGroup>
      </WpModalFooter>
    </WpModal>
  );
};

export default NavigationWarningModal;
